<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Import Personal Information</h1>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
          <v-alert
            border="top"
            color="red lighten-2"
            dark
            dismissible
            v-model="showError"
          >
            <v-row v-for="(err, key) in errors" :key="key">
              <v-col :class="classPadding">
                <span>• {{ err }}</span>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-file-input
            label="Import file"
            :class="classPadding"
            v-model="file"
          ></v-file-input>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-btn outlined :loading="isUploading" @click.prevent="upload"
            >Upload</v-btn
          >&nbsp;
          <v-btn
            color="success"
            outlined
            :loading="isSaving"
            @click.prevent="save"
            :disabled="hasError"
            v-if="userAccess.submit >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
      <list :items="list" :properties="properties"></list>

      <span class="caption" :class="classPadding">
        Click [
        <a @click="downloadFile">here</a>] to download the format.
      </span>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../mixins/userAccessMixin";
const List = () => import("./List");
const API_ENDPOINT = "/api/importpersonalinfo";
export default {
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    file: null,
    isUploading: false,
    isSaving: false,
    //hasError: false,
    errors: [],
    properties: [],
    uploadedItems: null,
    list: [],
    showError: false
  }),
  components: {
    List
  },
  computed: {
    hasError() {
      if (this.file === null && this.errors.length <= 0) return true;

      if (!(this.list.length > 0)) return true;

      return this.errors.length > 0 ? true : false;
    }
  },
  methods: {
    save() {
      this.$confirm("Are you sure you want to Save", {
        title: "Confirm"
      }).then(res => {
        if (res) {
          this.isSaving = true;
          this.$axios
            .post(`${API_ENDPOINT}/save`, this.list)
            .then(() => {
              this.$toast.success("Record Successfully Uploaded");
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            })
            .finally(() => {
              this.isSaving = false;
            });
        }
      });
    },
    upload() {
      this.isUploading = true;
      var formData = new FormData();

      formData.append("file", this.file);

      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}/upload`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          if (data.errors.length > 0) {
            this.errors = data.errors;
            this.properties = data.properties;
          } else {
            this.errors = [];
            this.properties = [];
          }

          this.uploadedItems = data;
          console.log(data.data)
          this.list = data.data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
    downloadFile() {
      var subPath = process.env.VUE_APP_PATH;

      window.open(
        `${subPath.slice(
          0,
          -1
        )}/Files/downloads/Personal Information Template.xlsx`
      );
    },
    reset() {
      (this.list = []), (this.file = null);
      this.uploadedItems = null;
    }
  },
  watch: {
    errors(val) {
      if (val.length > 0) this.showError = true;
      else this.showError = false;
    }
  },
  created() {
    this.getUserAccessRights("IUPERSON");
  }
};
</script>